import React from "react";
import TravelHeader from "../../components/travel/Header";
import TravelButton from "../../components/travel/Button";
import "./ThankYou.css";

export default function TravelThankYou({ onReset }) {
  return (
    <>
      <div className="tvty-root">
        <div className="tvty-header-wrap">
          <TravelHeader />
        </div>
        <main className="tvty-main">
          <div className="tvty-card">
            <div className="tvty-content">
              <div className="tvty-icon">
                <img
                  src="/assets/rightIcon.svg"
                  alt="Success"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <p className="tvty-title">Thanks for sharing your details</p>
              <p className="tvty-sub">Will contact with you shortly in sometime</p>
            </div>
            <div className="tvty-footer">
              <TravelButton variant="primary" clickText="Okay, got it!" onClick={onReset} id="thankyou-ok-btn" />
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
